import { createClient } from '@supabase/supabase-js';

// Environment variables (best practice)
const SUPABASE_URL = "https://vhotgvwqsavxrfivizeb.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZob3Rndndxc2F2eHJmaXZpemViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE5NjUxNjUsImV4cCI6MjA3NzU0MTE2NX0.5pEq4jWNhtLcg0GtS2iUIrGKolI_L6P4buUWnaxh1E8";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// console.log("✅ Supabase client created with URL:", SUPABASE_URL);
